import React from "react";
import { ArrowUpRight, Mail, MessageCircle, Phone } from "lucide-react";
import { CONTACT } from "../mock/mock";
import useReveal from "../hooks/useReveal";

export default function Contact() {
  const [ref, visible] = useReveal();

  const digits = CONTACT.phone.replace(/[^\d]/g, "");
  const whatsappMessage = encodeURIComponent(
    "Bună ziua! Aș dori mai multe detalii despre serviciile Planimex."
  );
  const whatsappHref = `https://wa.me/${digits}?text=${whatsappMessage}`;
  const phoneHref = `tel:${CONTACT.phone.replace(/\s/g, "")}`;

  return (
    <section id="contact" className="theme-dark section-pad border-t border-[var(--pl-line)] bg-[var(--pl-bg)] py-24 text-[var(--pl-text)] md:py-36">
      <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-16">
        <div className="lg:col-span-6">
          <h2
            className="font-display font-medium whitespace-nowrap text-[clamp(1.7rem,6.2vw,4.25rem)] tracking-[-0.01em]"
            style={{ fontFamily: "'Libre Baskerville', 'Times New Roman', 'Times', serif, !important" }}
          >
            Să începem proiectul tău
          </h2>
          <p className="mt-10 max-w-md text-[16px] leading-relaxed text-[var(--pl-text-2)] md:text-[17px]">
            {CONTACT.intro}
          </p>
        </div>

        <div className="lg:col-span-6 lg:col-start-8">
          <div
            ref={ref}
            className={`reveal ${visible ? "is-visible" : ""} flex flex-col gap-4`}
          >
            <a
              href={whatsappHref}
              target="_blank"
              rel="noopener noreferrer"
              className="group flex items-start justify-between gap-4 rounded border border-[var(--pl-card-border)] bg-[var(--pl-card-bg)] p-6 transition-all duration-300 hover:border-[#01B72C] hover:shadow-[0_10px_30px_rgba(1,183,44,0.12)]"
            >
              <div className="flex items-start gap-4">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-[#01B72C] text-white sm:h-12 sm:w-12">
                  <MessageCircle size={20} className="shrink-0" />
                </span>
                <div>
                  <div className="mono-label mb-2">WHATSAPP</div>
                  <p className="font-medium text-[var(--pl-text)]">Scrieți-ne pe WhatsApp</p>
                  <p className="mt-1 text-[15px] leading-relaxed text-[var(--pl-muted-text)] md:text-[16px]">
                    Răspundem rapid pentru detalii despre proiecte și servicii.
                  </p>
                </div>
              </div>
              <ArrowUpRight size={18} className="mt-1 shrink-0 text-[var(--pl-text-2)] transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>

            <a
              href={`mailto:${CONTACT.email}`}
              className="group flex items-start justify-between gap-4 rounded border border-[var(--pl-card-border)] bg-[var(--pl-card-bg)] p-6 transition-all duration-300 hover:border-[#01B72C] hover:shadow-[0_10px_30px_rgba(1,183,44,0.12)]"
            >
              <div className="flex items-start gap-4">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full border-[2px] border-[#01B72C] text-[#01B72C] sm:h-12 sm:w-12">
                  <Mail size={20} className="shrink-0" />
                </span>
                <div>
                  <p className="font-medium text-[var(--pl-text)]">{CONTACT.email}</p>
                  <p className="mt-1 text-[15px] leading-relaxed text-[var(--pl-muted-text)] md:text-[16px]">
                    Trimiteți-ne un mesaj și vă răspundem cu detalii despre proiectul dumneavoastră.
                  </p>
                </div>
              </div>
              <ArrowUpRight size={18} className="mt-1 shrink-0 text-[var(--pl-text-2)] transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>

            <a
              href={phoneHref}
              className="group flex items-start justify-between gap-4 rounded border border-[var(--pl-card-border)] bg-[var(--pl-card-bg)] p-6 transition-all duration-300 hover:border-[#01B72C] hover:shadow-[0_10px_30px_rgba(1,183,44,0.12)]"
            >
              <div className="flex items-start gap-4">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full border-[2px] border-[#01B72C] text-[#01B72C] sm:h-12 sm:w-12">
                  <Phone size={20} className="shrink-0" />
                </span>
                <div>
                  <p className="font-medium text-[var(--pl-text)]">{CONTACT.phone}</p>
                  <p className="mt-1 text-[15px] leading-relaxed text-[var(--pl-muted-text)] md:text-[16px]">
                    Apelați direct în aplicația telefonică de pe dispozitiv.
                  </p>
                </div>
              </div>
              <ArrowUpRight size={18} className="mt-1 shrink-0 text-[var(--pl-text-2)] transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
